export default __webpack_public_path__ + "static/media/about.97390334.png";